module.exports = __webpack_public_path__ + "media/assets/images/blog/giardiniere-df3ee700e5c342205a5a22e2e6103657.jpg";